<template>
  <div class="contentBox" :style="contentStyle" @mousewheel="wheelFn($event)">
    <ul class="ulList">
      <li
        :class="{active: nowIndex == index}"
        @click="changePage(index)"
        v-for="(item, index) in pageArrs"
        :key="index"
        class="liNode"
        :title="titleArrs[index]"
      ></li>
    </ul>
    <transition :name="transitionName">
      <component :is="nowPageName"></component>
    </transition>
  </div>
</template>
<script>
export default {
  name: 'ScrollPage',
  props: {
    titleArrs: {
      type: Array,
      default () {
        return []
      }
    },
    pageArrs: Array,
    contentStyle: Object,
    changeFn: Function
  },
  watch: {
    nowIndex(newVal){
      this.nowPageName = this.pageArrs[newVal]
    }
  },
  methods: {
    changePage(index){
      if(index == this.nowIndex){
        return false;
      }else if(index > this.nowIndex){
        this.transitionName = 'slide-left'
      }else{
        this.transitionName = 'slide-right'
      }
      this.nowIndex = index;
      this.changeFn?.(index);
    },
    wheelFn(e){
      let down = true;
      if(e.detail){
        down = e.detail > 0
      }else{
        down = e.wheelDelta < 0
      }
      if(!this.flag){
        this.flag = true;
        if(down){
          //向下滚动 --- 滚动到下一页
          (this.nowIndex == this.pageArrs.length - 1) ? this.nowIndex = 0 : ++this.nowIndex
          this.transitionName = 'slide-left'
        }else{
          //向上滚动 --- 滚动上一页
          (this.nowIndex == 0) ? this.nowIndex = this.pageArrs.length - 1 : --this.nowIndex
          this.transitionName = 'slide-right'
        }
        setTimeout(() => {
          this.flag = false;
        }, 3000)
      }
    },
  },
  data(){
    return {
      nowPageName: this.pageArrs[0],
      flag: false,
      nowIndex: 0,
      transitionName: 'slide-right',
    }
  }
}
</script>
<style lang="less" scoped>
  .contentBox{
    .banner();
    width: 100%;
    contain: layout;
  }
    // 进入过渡开始状态----向右移动
  .slide-right-enter{
    left:0;
    top: calc(0.11rem + 7.78%);
    right: 0;
    position: fixed;
    opacity: 0;
    transform: translateX(-1000px) scale(0.5);
  }
  // 进入过渡开始状态----向左移动
  .slide-left-enter{
    left:0;
    top: calc(0.11rem + 7.78%);
    right: 0;
    position: fixed;
    opacity: 0;
    transform: translateX(1000px) scale(0.5);
  }
  // 进入过渡生效状态
  .slide-right-enter-active,.slide-left-enter-active{
    transition: all 2s ease;
  }
  // 进入过渡结束状态
  .slide-right-enter-to,.slide-left-enter-to{
    opacity: 1;
    width: 100%;
    transform: translateX(0) scale(1);
  }
  // 离开过渡开始状态
  .slide-right-leave,.slide-left-leave{
    opacity: 1;
    width: 100%;
    transform: translateX(0) scale(1);
  }
  // 离开过渡生效状态
  .slide-right-leave-active,.slide-left-leave-active{
    transition: all 2s ease;
  }
  // 离开过渡结束状态
  .slide-right-leave-to{
    left:0;
    top: calc(0.11rem + 7.78%);
    right: 0;
    position: fixed;
    opacity: 0;
    transform: translate(1000px) scale(0.5);
  }
  .slide-left-leave-to{
    left:0;
    top: calc(0.11rem + 7.78%);
    right: 0;
    position: fixed;
    opacity: 0;
    transform: translate(-1000px) scale(0.5);
  }
  .ulList{
    z-index: 999;
    height: 50%;
    position: absolute;
    right: -0.2rem;
    top: 50%;
    margin-top: -15%;
    .flexColumnAround();
    .liNode{
      cursor: pointer;
      width: 0.15rem;
      height: 0.15rem;
      border-radius: 50%;
      background: #fff;
    }
    .active{
      background: #02D9FD;
    }
  }
</style>